import { styled } from '@mui/material/styles';

export const StyledLink = styled('a')(
  ({ theme }) => `
    display: block;
    background-color:${theme.DS_palette.primary.white};
    color: ${theme.DS_palette.buttons.enabled};
    border: ${theme.DS_border.width.button} solid ${theme.DS_palette.buttons.enabled};
    border-radius: ${theme.DS_border.radius.button};
    text-align: center;
    :active,
    :focus {
      border: ${theme.DS_border.width.button} solid ${theme.DS_palette.buttons.pressed};
      color: ${theme.DS_palette.buttons.pressed};
    }
     
    :hover {
      background-color: ${theme.DS_palette.buttons.text.hover};
      border: ${theme.DS_border.width.button} solid ${theme.DS_palette.buttons.enabled};
      color: ${theme.DS_palette.buttons.enabled};
    }
    
     padding: 10px ${theme.DS_spacing(['xs'])};
     min-height: 44px;
     min-width: 164px;
  
     ${theme.breakpoints.up('lg')} {
      min-height: 52px;
      min-width: 200px;
      padding: ${theme.DS_spacing(['xs'])};
     } 

`,
);
